<template>
  <div class="cross-sell-edit-btn">
    <span class="icon_pencil cross-sell-edit-btn__icon"
      ><pen style="height: 13px; width: 13px"
    /></span>
    <span>{{ $t('cross_sell.customize') }}</span>
  </div>
</template>

<script>
import Pen from '~/components/icons/pen/Pen'
export default {
  name: 'CrossSellEditBtn',
  components: {
    Pen,
  },
}
</script>

<style lang="scss" scoped>
.cross-sell-edit-btn {
  margin-top: 5px;
  font-size: 11px;
  line-height: initial;
  border: 1px solid $color_gray;
  background-color: #fff;
  padding: 0 6px 0 24px;
  cursor: pointer;
  display: inline-block;
  color: #666;
  position: relative;

  .cross-sell-edit-btn__icon {
    height: auto;
    line-height: 13px;
    position: absolute;
    top: 3px;
    left: 6px;
    // transform: rotate(90deg);
  }

  span {
    height: 19px;
    line-height: 19px;
    display: inline-block;
  }
}
</style>
